// dependecies import ==>
import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import moment from "moment";
// assets and scss import ==>
import "./vcAgeWiseView.scss";
import closeIcon from "../../../../../assets/close_icon.svg";
import VCAgeWiseTableView from "../VCAgeWiseTableView";
import C2CCustomPopup from "../../../../common/Popups/C2CCustomPopup";
import FormInputWithHeader from "../../../../common/FormInputWithHeader";
import VCEditVaccineView from "../VCEditVaccineView";
import {
  CREATE_EDIT_CUSTOM_VACCINE,
  CREATE_EDIT_PRE_VACCINE,
  DELETE_CUSTOM_VACCINE,
  GET_VACCINE_BRANDS,
  SCHEDULE_NEXT_DUE_DATE,
} from "../VCViewApiHandler/apiConstants";
import { C2CConsole } from "../../../../../Util/Helper/C2CConsole";
import { DEFAULT_EDIT_VACCINE } from "../constants";
import { ADD_EDIT_VITALS } from "../../../ERXViewApiHandler/apiConstants";
import { LOCALSTORAGEKEY } from "../../../../../Util/Helper/localStorageUtils";
import { c2cPostApiHandler } from "../../../../../Util/c2cApiHandler";
// project file import ==>

// constant import ==>

const VCAgeWiseView = (props) => {
  const {
    appointmentData,
    vaccineList,
    patientDob,
    updatedGender,
    generalVaccineList,
    isAgeAboveSixteen,
    vaccineNotes,
    vitalsList,
    prescription_id,
    addEditVitals,
    prescriptionVitals,
    searchVaccine,
    setSearchVaccine,
    handleVaccineNotes,
    setVaccineList,
    setLoader,
    setGeneralVaccineList,
    getVaccines,
    fetchVitals,
  } = props;

  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const userType = localStorage.getItem(LOCALSTORAGEKEY.USER_TYPE);

  const [searchClicked, setSearchClicked] = useState(false);
  const [vaccineBrands, setVaccineBrands] = useState([]);
  const [showEditVaccineModal, setShowEditVaccineModal] = useState(false);
  const [showAddVaccineModal, setShowAddVaccineModal] = useState(false);
  const [vaccineName, setVaccineName] = useState("");
  const [editedVaccineDetails, setEditedVaccineDetails] = useState(
    JSON.parse(JSON.stringify(DEFAULT_EDIT_VACCINE))
  );
  const [disableSaveButton, setDisableSaveButton] = useState(true);
  const [isCustomValue, setIsCustomValue] = useState(false);
  const [addNewVaccine, setAddNewVaccine] = useState({});

  // Lifecycle Methods ===>

  useEffect(() => {
    if (
      (editedVaccineDetails?.scheduled_date &&
        editedVaccineDetails?.vaccinated_date &&
        (editedVaccineDetails?.vaccine_brand_name ||
          editedVaccineDetails?.weight ||
          editedVaccineDetails?.height ||
          editedVaccineDetails?.head_circumference)) ||
      (editedVaccineDetails?.scheduled_date &&
        editedVaccineDetails?.vaccinated_date &&
        !editedVaccineDetails?.vaccine_brand_name &&
        !editedVaccineDetails?.weight &&
        !editedVaccineDetails?.height &&
        !editedVaccineDetails?.head_circumference) ||
      (editedVaccineDetails?.scheduled_date &&
        !editedVaccineDetails?.vaccinated_date &&
        !editedVaccineDetails?.vaccine_brand_name &&
        !editedVaccineDetails?.weight &&
        !editedVaccineDetails?.height &&
        !editedVaccineDetails?.head_circumference)
    ) {
      setDisableSaveButton(false);
    } else {
      setDisableSaveButton(true);
    }
  }, [editedVaccineDetails]);

  // <===

  // Helper Methods ===>

  const handleDueDateForNewVaccine = (title) => {
    let scheduled_date = "";
    if (patientDob && !isAgeAboveSixteen) {
      if (title?.toLowerCase().includes("birth")) {
        scheduled_date = moment(new Date(patientDob))
          .add("1", "d")
          .format("DD MMM YYYY");
      } else if (title?.toLowerCase().includes("weeks")) {
        scheduled_date = getDueDates(title, "weeks", "w");
      } else if (title?.toLowerCase().includes("months")) {
        scheduled_date = getDueDates(title, "months", "M");
      } else if (title?.toLowerCase().includes("years")) {
        scheduled_date = getDueDates(title, "years", "Y");
      }
    }

    return scheduled_date;
  };

  const getDueDates = (title, splitBy, addBy) => {
    let scheduled_date = "";
    let data = title?.toLowerCase().split(splitBy)[0]?.trim();
    if (title?.includes("-")) {
      data = title?.toLowerCase().split("-")[0]?.trim();
    }
    scheduled_date = moment(patientDob).add(data, addBy).format("DD MMM YYYY");
    return scheduled_date;
  };

  const getNextDueDate = () => {
    let futureDueDates = [];
    let minDate = null;
    let nextDueVaccines = [];
    vaccineList.forEach((ele) => {
      ele.vaccines.forEach((item) => {
        if (
          item.scheduled_date &&
          moment(new Date(item.scheduled_date), "YYYY/MM/DD")
            .hours(0)
            .minutes(0)
            .seconds(0)
            .milliseconds(0)
            .isAfter(moment().hours(0).minutes(0).seconds(0).milliseconds(0)) &&
          !item.vaccinated_date &&
          (item.vaccine_id
            ? item.vaccine_id !== editedVaccineDetails?.vaccine_id
            : true) &&
          (item.prescription_vaccination_id
            ? item.prescription_vaccination_id !==
              editedVaccineDetails?.prescription_vaccination_id
            : true)
        ) {
          futureDueDates.push(item);
        }
      });
    });

    generalVaccineList.forEach((ele) => {
      ele.vaccines.forEach((item) => {
        if (
          item.scheduled_date &&
          moment(new Date(item.scheduled_date), "YYYY/MM/DD")
            .hours(0)
            .minutes(0)
            .seconds(0)
            .milliseconds(0)
            .isAfter(moment().hours(0).minutes(0).seconds(0).milliseconds(0)) &&
          !item.vaccinated_date &&
          (item.vaccine_id
            ? item.vaccine_id !== editedVaccineDetails?.vaccine_id
            : true) &&
          (item.prescription_vaccination_id
            ? item.prescription_vaccination_id !==
              editedVaccineDetails?.prescription_vaccination_id
            : true)
        ) {
          futureDueDates.push(item);
        }
      });
    });

    if (futureDueDates?.length !== 0) {
      minDate = Math.min(
        ...futureDueDates.map((ele) => {
          return new Date(ele.scheduled_date);
        })
      );

      nextDueVaccines = futureDueDates.filter(
        (ele) =>
          ele.scheduled_date === moment(new Date(minDate)).format("DD MMM YYYY")
      );
      nextDueVaccines = nextDueVaccines.map((ele) => {
        return ele["name"];
      });
    }

    return [minDate ? new Date(minDate) : null, nextDueVaccines];
  };

  const getVitalValue = (item, data) => {
    let value = item[data.key];
    if (item[data.key]) {
      value = item[data.key];
    } else if (vitalsList[data.key]) {
      value = vitalsList[data.key];
    }

    return value;
  };

  const getVitalUnit = (item, data) => {
    let unit = data.unit;
    if (item[data.key]) {
      unit = item[data.key + "_unit"];
    } else if (vitalsList[data.key] && vitalsList[data.key + "_unit"]) {
      unit = vitalsList[data.key + "_unit"];
    } else if (item[data.key + "_unit"]) {
      unit = item[data.key + "_unit"];
    }

    return unit;
  };

  // <===

  // Actions ===>

  const handleShowSearchInput = () => {
    setSearchClicked(true);
  };

  const handleVaccineSearch = (e) => {
    setSearchVaccine(e.target.value);
  };

  const handleClearSearch = () => {
    setSearchVaccine("");
    setSearchClicked(false);
  };

  const handleToggleArrow = (item) => {
    let ind = vaccineList.findIndex((ele) => ele.title === item.title);
    vaccineList[ind].expand = !vaccineList[ind].expand;
    setVaccineList([...vaccineList]);
  };

  const handleToggleGeneralVaccines = (item) => {
    let ind = generalVaccineList.findIndex((ele) => ele.title === item.title);
    generalVaccineList[ind].expand = !generalVaccineList[ind].expand;
    setGeneralVaccineList([...generalVaccineList]);
  };

  const handleEditVaccineModal = (item) => {
    getVaccineBrand(item);
    let editVitals = JSON.parse(JSON.stringify(DEFAULT_EDIT_VACCINE));
    editVitals.vitals_list.forEach((data) => {
      data.value = getVitalValue(item, data);
      data.unit = getVitalUnit(item, data);
      editVitals[data.key] = data.value;
      editVitals[data.key + "_unit"] = data.unit;
    });

    setEditedVaccineDetails({
      ...item,
      ...editVitals,
    });
  };

  const handleAddVaccineModal = (value, item) => {
    setVaccineName("");
    if (value) {
      let prevElement = item.vaccines[item.vaccines.length - 1];

      setAddNewVaccine({
        ...prevElement,
        vaccine_id: "",
        vaccine_name: "",
        vaccine_category_id: "",
        vaccine_brand_name: "",
        scheduled_date: handleDueDateForNewVaccine(item?.title),
        vaccinated_date: "",
        height: "",
        weight: "",
        head_circumference: "",
        height_unit: "",
        weight_unit: "",
        head_circumference_unit: "",
        master_vaccine_brand_id: "",
        master_vaccine_schedule_id: prevElement?.vaccine_schedule_id,
        prescription_vaccination_id: "",
      });
    }
    setShowAddVaccineModal(value);
  };

  const handleVaccineNameChange = (e) => {
    if (e.target.value?.length <= 50) {
      setVaccineName(e.target.value);
    }
  };

  const handleAddVaccine = () => {
    handleAddVaccineModal(false, null);
    addEditPreOrCustomVaccine({
      ...addNewVaccine,
      name: vaccineName,
      custom_vaccine: true,
    });
  };

  const handleVaccineBrand = (val) => {
    if (val.value === "Other") {
      setEditedVaccineDetails({
        ...editedVaccineDetails,
        vaccine_brand_name: "",
        vaccine_brand_id: "",
      });
      setIsCustomValue(true);
    } else {
      setEditedVaccineDetails({
        ...editedVaccineDetails,
        vaccine_brand_name: val.value,
        vaccine_brand_id: val.id,
      });
      setIsCustomValue(false);
    }
  };

  const handleVaccineBrandInput = (e) => {
    if (e.target.value?.length <= 50) {
      setEditedVaccineDetails({
        ...editedVaccineDetails,
        vaccine_brand_name: e.target.value,
      });
    }
  };

  const handleDueDateChange = (date) => {
    setEditedVaccineDetails({
      ...editedVaccineDetails,
      scheduled_date: moment(date).format("DD MMM YYYY"),
    });
  };

  const handleVaccineDateChange = (date) => {
    setEditedVaccineDetails({
      ...editedVaccineDetails,
      vaccinated_date: moment(date).format("DD MMM YYYY"),
    });
  };

  const handleVitalsChange = (e, item) => {
    let index = editedVaccineDetails?.vitals_list?.findIndex(
      (vi) => vi.id === item.id
    );
    editedVaccineDetails.vitals_list[index].value = e.target.value;
    editedVaccineDetails[item.key] = e.target.value;
    setEditedVaccineDetails({ ...editedVaccineDetails });
  };

  const handleUpArrowClick = (item) => {
    let index = editedVaccineDetails?.vitals_list.findIndex(
      (vi) => vi.id === item.id
    );
    let ind = editedVaccineDetails?.vitals_list[index]?.unitList?.findIndex(
      (un) => un === editedVaccineDetails?.vitals_list[index]?.unit
    );

    if (editedVaccineDetails?.vitals_list[index]?.unitList[ind + 1]) {
      editedVaccineDetails.vitals_list[index].unit =
        editedVaccineDetails?.vitals_list[index]?.unitList[ind + 1];
    } else {
      editedVaccineDetails.vitals_list[index].unit =
        editedVaccineDetails?.vitals_list[index]?.unitList[0];
    }
    editedVaccineDetails[
      editedVaccineDetails?.vitals_list[index]?.name?.toLowerCase() + "_unit"
    ] = editedVaccineDetails.vitals_list[index].unit;
    setEditedVaccineDetails({ ...editedVaccineDetails });
  };

  const handleDownArrowClick = (item) => {
    let index = editedVaccineDetails?.vitals_list?.findIndex(
      (vi) => vi.id === item.id
    );
    let ind = editedVaccineDetails?.vitals_list[index]?.unitList?.findIndex(
      (un) => un === editedVaccineDetails?.vitals_list[index]?.unit
    );
    if (editedVaccineDetails?.vitals_list[index]?.unitList[ind - 1]) {
      editedVaccineDetails.vitals_list[index].unit =
        editedVaccineDetails?.vitals_list[index]?.unitList[ind - 1];
    } else {
      editedVaccineDetails.vitals_list[index].unit =
        editedVaccineDetails?.vitals_list[index]?.unitList[
          editedVaccineDetails.vitals_list[index].unitList.length - 1
        ];
    }
    editedVaccineDetails[
      editedVaccineDetails?.vitals_list[index]?.name?.toLowerCase() + "_unit"
    ] = editedVaccineDetails?.vitals_list[index]?.unit;
    setEditedVaccineDetails({ ...editedVaccineDetails });
  };

  const handleSaveEditedVaccine = () => {
    setShowEditVaccineModal(false);
    setIsCustomValue(false);
    addEditPreOrCustomVaccine(editedVaccineDetails);
    updateVitals(editedVaccineDetails);
    if (editedVaccineDetails?.vaccinated_date) {
      scheduleNextDueDateApi();
    }
  };

  const handleCloseEditPopup = () => {
    setShowEditVaccineModal(false);
    setIsCustomValue(false);
  };

  // <===

  // Api Calls ===>

  const scheduleNextDueDateApi = () => {
    let [nextDueDate, upcomingVaccines] = getNextDueDate();
    if (nextDueDate) {
      let payload = {
        appointment_id: appointmentData?.appointment_id,
        due_date: moment(nextDueDate).format("DD-MM-YYYY"),
        vaccines: upcomingVaccines,
        prescription_id: prescription_id,
        category: "vaccine",
      };

      c2cPostApiHandler(SCHEDULE_NEXT_DUE_DATE, payload).then(
        ([res, error]) => {
          if (!error) {
            if (res?.data?.statusCode === 200) {
              C2CConsole.log(res);
            }
          }
        }
      );
    }
  };

  const updateVitals = (data) => {
    let allVitals = {};
    if (Object.keys(addEditVitals.value)?.length === 0) {
      prescriptionVitals.forEach((ele) => {
        allVitals[ele.name.toLowerCase().replace(" ", "_")] = ele.value;
        allVitals[ele.name.toLowerCase().replace(" ", "_") + "_unit"] =
          ele.unit;
      });
    }
    let payload = {
      ...addEditVitals?.value,
      ...allVitals,
      weight: data?.weight,
      height: data?.height,
      weight_unit: data?.weight_unit,
      height_unit: data?.height_unit,
      head_circumference: data?.head_circumference,
      head_circumference_unit: data?.head_circumference_unit,
      appointment_id: appointmentData?.appointment_id,
      user_id: userId,
      user_type: userType,
    };

    c2cPostApiHandler(ADD_EDIT_VITALS, payload).then(([res, error]) => {
      if (!error) {
        if (res?.data?.statusCode === 200) {
          C2CConsole.log(res);
          fetchVitals();
        }
      }
    });
  };

  const getVaccineBrand = (item) => {
    setLoader(true);
    let payload = {
      vaccine_category_id: item?.vaccine_category_id ?? "",
    };
    let resData = c2cPostApiHandler(GET_VACCINE_BRANDS, payload);
    resData.then(([res, err]) => {
      if (!err && res?.data?.statusCode === 200) {
        res.data.data.forEach((ele) => {
          ele.vaccine.forEach((vac) => {
            vac.label = vac.name;
            vac.value = vac.name;
          });
        });

        let brands = res?.data?.data
          ?.map((ele) => {
            return ele.vaccine;
          })
          .flat(1);

        brands.push({
          id: "",
          name: "Other",
          value: "Other",
          label: "Other",
        });

        setVaccineBrands([...brands]);
        setLoader(false);
        setShowEditVaccineModal(true);
      } else {
        setLoader(false);
      }
    });
  };

  const addEditPreOrCustomVaccine = (data) => {
    setLoader(true);
    let payload = {
      prescription_id: data?.prescription_id
        ? data?.prescription_id
        : prescription_id,
      vaccine_id: data?.vaccine_id ?? "",
      vaccine_name: data?.name,
      vaccine_category_id: data?.vaccine_category_id ?? "",
      vaccine_brand_name: data?.vaccine_brand_name ?? "",
      scheduled_date: data?.scheduled_date
        ? moment(data?.scheduled_date).format("YYYY-MM-DD")
        : "",
      vaccinated_date: data?.vaccinated_date
        ? moment(data?.vaccinated_date).format("YYYY-MM-DD")
        : "",
      patient_account_id: appointmentData?.patient_account_id,
      height: data?.height ?? "",
      weight: data?.weight ?? "",
      head_circumference: data?.head_circumference ?? "",
      height_unit: data?.height_unit ?? "",
      weight_unit: data?.weight_unit ?? "",
      head_circumference_unit: data?.head_circumference_unit ?? "",
      master_vaccine_brand_id: data?.vaccine_brand_id ?? "",
      master_vaccine_schedule_id: data?.vaccine_schedule_id ?? "",
      prescription_vaccination_id: data?.prescription_vaccination_id ?? "",
    };
    let api = data?.custom_vaccine
      ? CREATE_EDIT_CUSTOM_VACCINE
      : CREATE_EDIT_PRE_VACCINE;
    let resData = c2cPostApiHandler(api, payload);
    resData.then(([res, err]) => {
      if (!err && res?.data?.statusCode === 200) {
        C2CConsole.log(res?.data?.message);
        getVaccines();
      } else {
        setLoader(false);
      }
    });
  };

  const handleDeleteVaccine = (item) => {
    setLoader(true);
    let payload = {
      prescription_vaccination_id: item?.prescription_vaccination_id,
    };

    let resData = c2cPostApiHandler(DELETE_CUSTOM_VACCINE, payload);
    resData.then(([res, err]) => {
      if (!err && res?.data?.statusCode === 200) {
        C2CConsole.log(res?.data?.message);
        getVaccines();
      } else {
        setLoader(false);
      }
    });
  };

  // <===

  //Display UI ===>

  const displayVaccineChartHeader = () => {
    return (
      <div
        className="vc-age-wise-view-header"
        style={{
          display: searchClicked && window.innerWidth < 768 ? "block" : "",
        }}
      >
        <div className="vc-age-wise-view-header-text">Available Vaccine</div>
        <div>
          {searchClicked ? (
            <div className="vc-age-wise-view-header-search-container">
              <input
                value={searchVaccine}
                autoFocus={true}
                onChange={handleVaccineSearch}
                placeholder="Search Vaccine"
              />
              <img alt="" src={closeIcon} onClick={handleClearSearch} />
            </div>
          ) : (
            <div className="vc-age-wise-view-header-search-icon">
              <SearchIcon onClick={handleShowSearchInput} />
            </div>
          )}
        </div>
      </div>
    );
  };

  const displayVaccineChartTable = () => {
    let filteredVaccineList = vaccineList.filter((ele) => {
      if (ele.title?.toLowerCase().includes("9 years")) {
        if (updatedGender?.toLowerCase() === "female") {
          return ele;
        }
      } else {
        return ele;
      }
    });
    return (
      <div className="vc-age-wise-vaccine-table">
        {filteredVaccineList.map((item) => (
          <div key={item.title}>
            {item.show && (
              <div style={{ marginBottom: "10px" }}>
                <VCAgeWiseTableView
                  ageWiseHeader={item.title}
                  expand={item.expand}
                  vaccines={item.vaccines}
                  searchVaccine={searchVaccine}
                  appointmentData={appointmentData}
                  handleToggleArrow={() => handleToggleArrow(item)}
                  handleEditVaccineModal={handleEditVaccineModal}
                  handleAddVaccineModal={() =>
                    handleAddVaccineModal(true, item)
                  }
                  handleDeleteVaccine={handleDeleteVaccine}
                />
              </div>
            )}
          </div>
        ))}
        <div
          className="vc-age-wise-view-header-text"
          style={{ margin: "10px 0" }}
        >
          General Vaccines
        </div>
        {generalVaccineList.map((item) => (
          <div key={item.title}>
            {item.show && (
              <div style={{ marginBottom: "10px" }}>
                <VCAgeWiseTableView
                  ageWiseHeader="Vaccines"
                  expand={item.expand}
                  vaccines={item.vaccines}
                  searchVaccine={searchVaccine}
                  appointmentData={appointmentData}
                  handleToggleArrow={() => handleToggleGeneralVaccines(item)}
                  handleEditVaccineModal={handleEditVaccineModal}
                  handleAddVaccineModal={() =>
                    handleAddVaccineModal(true, item)
                  }
                  handleDeleteVaccine={handleDeleteVaccine}
                />
              </div>
            )}
          </div>
        ))}
        <div className="mt-3">{renderNotesInput()}</div>
      </div>
    );
  };

  const renderNotesInput = () => {
    return (
      <div className="doctor-notes-view-notes">
        <p className="m-0">Notes</p>
        <textarea
          maxLength={250}
          rows="4"
          value={vaccineNotes?.value}
          onChange={(e) => handleVaccineNotes(e.target.value)}
        ></textarea>
      </div>
    );
  };

  const displayEditVaccineModal = () => {
    return (
      <C2CCustomPopup
        openPopup={showEditVaccineModal}
        popupHeading="Edit Vaccine"
        middleBtn="Save"
        dialogClassName="edit-vaccine-modal"
        middleBtnDisabled={disableSaveButton}
        handleClosePopup={handleCloseEditPopup}
        handleMiddleBtnClick={handleSaveEditedVaccine}
      >
        <VCEditVaccineView
          editedVaccineDetails={editedVaccineDetails}
          isCustomValue={isCustomValue}
          vaccineBrands={vaccineBrands}
          handleVaccineBrand={handleVaccineBrand}
          handleVaccineBrandInput={handleVaccineBrandInput}
          handleDueDateChange={handleDueDateChange}
          handleVaccineDateChange={handleVaccineDateChange}
          handleVitalsChange={handleVitalsChange}
          handleUpArrowClick={handleUpArrowClick}
          handleDownArrowClick={handleDownArrowClick}
        />
      </C2CCustomPopup>
    );
  };

  const displayAddVaccineModal = () => {
    return (
      <C2CCustomPopup
        openPopup={showAddVaccineModal}
        popupHeading="Custom Vaccine"
        middleBtn="Add Vaccine"
        // dialogClassName="add-vaccine-modal"
        middleBtnDisabled={vaccineName?.trim()?.length === 0}
        handleClosePopup={() => handleAddVaccineModal(false, null)}
        handleMiddleBtnClick={handleAddVaccine}
      >
        <div style={{ width: window.innerWidth > 768 ? "350px" : "100%" }}>
          <FormInputWithHeader
            title=""
            placeholder="Enter Vaccine Name"
            maxLimit={50}
            value={vaccineName}
            handleOnChangeInput={handleVaccineNameChange}
          />
        </div>
      </C2CCustomPopup>
    );
  };

  // <===

  return (
    <div className="vc-age-wise-view-container">
      <div className="vc-age-wise-view-container-popup">
        {displayVaccineChartHeader()}
        {displayVaccineChartTable()}
      </div>
      {showEditVaccineModal && displayEditVaccineModal()}
      {showAddVaccineModal && displayAddVaccineModal()}
    </div>
  );
};

export default VCAgeWiseView;
